export default "__VITE_ASSET__CRWKa1x8__"